import React from 'react';
import classNames from 'classnames';
import styles from './LoginButton.module.scss';

const LoginButton = ({ onLogin }) => {
  return (
    <div className={classNames(styles.logInClass)} onClick={onLogin}>
      登录/注册
    </div>
  );
};

export default LoginButton;
